export class MultiVendorSkuDto {
    public readonly primarySku: string;
    public readonly primarySkuDistributorCode: string;
    public readonly primarySkuName: string;
    public readonly alternateSku1: string | null;
    public readonly alternateSku1DistributorCode: string | null;
    public readonly alternateSku1Name: string | null;
    public readonly alternateSku2: string | null;
    public readonly alternateSku2DistributorCode: string | null;
    public readonly alternateSku2Name: string | null;

    constructor(primarySku: string,
                primarySkuDistributorCode: string,
                primarySkuName: string,
                alternateSku1: string | null,
                alternateSku1DistributorCode: string | null,
                alternateSku1Name: string | null,
                alternateSku2: string | null,
                alternateSku2DistributorCode: string | null,
                alternateSku2Name: string | null) {
        this.primarySku = primarySku;
        this.primarySkuDistributorCode = primarySkuDistributorCode;
        this.primarySkuName = primarySku;
        this.alternateSku1 = alternateSku1;
        this.alternateSku1DistributorCode = alternateSku1DistributorCode;
        this.alternateSku1Name = alternateSku1Name;
        this.alternateSku2 = alternateSku2;
        this.alternateSku2DistributorCode = alternateSku2DistributorCode;
        this.alternateSku2Name = alternateSku2Name;
    }
}
